import type { MarketingContentIndexEntry } from "./marketingContentLoader";
import { getMarketingPageHeading } from "./marketingPageHeading";
import siteStructuredData from "./siteStructuredData.json";

/** Use identical, script-safe text in the static HTML and Helmet so hydration retains one script. */
function serializeStructuredData(value: unknown): string {
  return JSON.stringify(value).replace(/</g, "\\u003c");
}

export function buildBlogPostingJsonLd({ entry, canonicalUrl, imageUrl, htmlLanguage }: {
  entry: MarketingContentIndexEntry;
  canonicalUrl: string;
  imageUrl: string;
  htmlLanguage: string;
}): string {
  return serializeStructuredData({
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: getMarketingPageHeading(entry),
    description: entry.description,
    inLanguage: htmlLanguage,
    image: imageUrl,
    mainEntityOfPage: canonicalUrl,
    publisher: { "@type": "Organization", name: "Jungle" },
    ...(entry.publishedDate ? { datePublished: entry.publishedDate } : {}),
    ...(entry.author ? { author: { "@type": "Person", name: entry.author } } : {}),
  });
}

export function buildLandingStructuredDataJsonLd({ title, description, canonicalUrl, htmlLanguage }: {
  title: string;
  description: string;
  canonicalUrl: string;
  htmlLanguage: string;
}): string {
  return serializeStructuredData({
    ...siteStructuredData,
    "@graph": [
      ...siteStructuredData["@graph"],
      {
        "@type": "WebPage",
        "@id": `${canonicalUrl}#webpage`,
        url: canonicalUrl,
        name: title,
        description,
        inLanguage: htmlLanguage,
        isPartOf: { "@id": "https://jungleai.com/#website" },
        about: { "@id": "https://jungleai.com/#organization" },
      },
    ],
  });
}
